module.exports = __webpack_public_path__ + "img/36.f55eb203.jpg";